<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'businessContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info-view :contract-num="contractNum" :info="info" @initInfo="initInfo" />
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="0" label="合同明细">
        <productDetail2 :contract-id="info.id" :department-code="info.departmentCode" :str-contract-code="contractNum" :contract-type="info.contractType" :special-product="info.specialProduct" :special-cloud-desc="info.specialCloudDesc" :multiaddress-value="info.multiaddressValue" :multiaddress="info.multiaddress" :project-name="info.projectName" :order-unit="info.orderUnit" :sold-country="info.soldCountry" />
      </rj-tab-pane>
      <rj-tab-pane name="1" label="订单明细">
        <contractual-product :str-contract-code="contractNum" :sales-type="info.salesType" :contract-type="info.contractType" />
      </rj-tab-pane>
      <rj-tab-pane name="7" label="约定交付日期">
        <delivery-date :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="发货明细">
        <logistics-info :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="6" label="序列号明细">
        <serial-number id="" :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane name="4" label="开票明细">
        <invoice-details :str-contract-code="contractNum" :contract-type="info.contractType" />
      </rj-tab-pane>
      <rj-tab-pane name="5" label="分配明细">
        <pay-for-details v-if="info.id" :contract-id="info.id" :contract-type="info.contractType" :contract-status="info.contractStatus" :is-cancle-pay-money="false" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import contractualProduct from '@/views/Chief/contract/common/contractualProduct';
import baseInfoView from './BaseInfo';
import serialNumber from '@/views/Chief/contract/common/serialNumber';
import productDetail2 from '../components/productDetail2'; // 合同详情组件
import payForDetails from '@/views/Chief/contract/common/payForDetails';
import InvoiceDetails from '@/views/Chief/contract/common/InvoiceDetails';
import deliveryDate from '@/views/Chief/contract/common/deliveryDate';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import logisticsInfo from './logisticsInfo.vue';
export default {
  data () {
    return {
      tabsActive: '0',
      info: {}
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    contractualProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    logisticsInfo,
    serialNumber,
    baseInfoView,
    InvoiceDetails,
    payForDetails,
    deliveryDate,
    productDetail2
  },
  computed: {},
  methods: {
    initInfo (info) {
      this.info = info;
      console.log('查看info-----', info);
    }
  },
  mounted () {
  }
};
</script>
